import { render, staticRenderFns } from "./ModaleHeader.vue?vue&type=template&id=4da6d924&"
import script from "./ModaleHeader.vue?vue&type=script&lang=js&"
export * from "./ModaleHeader.vue?vue&type=script&lang=js&"
import style0 from "./ModaleHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports